import { getTg } from '../core/telegram.js';
import type { AppUser } from '../types/api.js';

let isOwnerApp = false;
let buildBetaAccess = false;
let isUpgradeMode = false;
let ownerTabBound = false;
let tgThemeBound = false;
let currentUser: AppUser | null = null;

export function getCurrentUser(): AppUser | null {
  return currentUser;
}

export function setCurrentUser(user: AppUser | null | undefined): void {
  currentUser = user || null;
}

export function syncCurrentUserFromTelegram(): AppUser | null {
  const tg = getTg();
  currentUser =
    tg && tg.initDataUnsafe && tg.initDataUnsafe.user ? tg.initDataUnsafe.user : null;
  return currentUser;
}

export function getIsOwnerApp(): boolean {
  return isOwnerApp;
}

export function setIsOwnerApp(value: boolean): void {
  isOwnerApp = !!value;
}

export function getBuildBetaAccess(): boolean {
  return buildBetaAccess;
}

export function setBuildBetaAccess(value: boolean): void {
  buildBetaAccess = !!value;
}

export function getIsUpgradeMode(): boolean {
  return isUpgradeMode;
}

export function setIsUpgradeMode(value: boolean): void {
  isUpgradeMode = !!value;
}

export function getOwnerTabBound(): boolean {
  return ownerTabBound;
}

export function setOwnerTabBound(value: boolean): void {
  ownerTabBound = !!value;
}

export function getTgThemeBound(): boolean {
  return tgThemeBound;
}

export function setTgThemeBound(value: boolean): void {
  tgThemeBound = !!value;
}

export function bootstrapAppState(): void {
  syncCurrentUserFromTelegram();
  isOwnerApp = false;
  isUpgradeMode = false;
  ownerTabBound = false;
  tgThemeBound = false;
}
